import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-media-object',
  templateUrl: './ui-media-object.component.html',
  styleUrls: ['./ui-media-object.component.scss']
})
export class UiMediaObjectComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
